package com.appcreator.client.firebase.messaging

import com.russhwolf.settings.Settings

class TopicStore(
    private val settings: Settings
) {

    companion object {
        private const val TOPICS_KEY = "com.appcreator.client.firebase.messaging.topics"
    }

    fun getTopics(): Set<String> {
        return settings.getString(TOPICS_KEY, "").split(",").toSet()
    }

    private fun setTopics(topics: Set<String>) {
        settings.putString(TOPICS_KEY, topics.joinToString(","))
    }

    fun addTopic(topic: String) {
        setTopics(getTopics().plus(topic))
    }

    fun removeTopic(topic: String) {
        setTopics(getTopics().minus(topic))

    }

}